"use strict";
import {on, find, findAllIn, findIn, closest} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import axios from "axios";

export function init() {
    onFind('.js-file-upload', function (element) {
        on('change', function () {
            let pendingRequest = axios({
                method: 'POST',
                url: element.getAttribute('data-action'),
                data: new FormData(element)
            });
            Append(pendingRequest, element);
        }, element);
    });

    onFind('.js-file-upload__reset', function(reset){
        let element = closest('.js-file-upload', reset);

        on('click', (e) => {
            let pendingRequest = axios({
                method: 'POST',
                url: reset.getAttribute('data-action')
            });
            Append(pendingRequest, element)
        }, reset);
    })
}
function Append(pendingRequest, element){
    asyncAppend({
        target: findAllIn('.js-file-upload__result', element),
        loading: findAllIn('.js-file-upload__loading', element)
    }, pendingRequest.then((x) => x.data));
}